import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  assignPassword,
  changePassword,
  tokenValidation,
  SendUserActivationEmail,
} from "../../../actions/auth.action.entry";

import SimpleReactValidator from "simple-react-validator";
import { reactValidatorOptions } from "../../../helpers/simpleReactValidator";
import {
  hasNumbers,
  hasLowerLetter,
  hasUpperLetter,
  hasSpecialCharacter,
  isCorrectLength,
  isCorrectMaxLength,
} from "../../../helpers/regex.helper";

import { encryptionKey, encryptionIv } from "../../../config/config.entry";
import PageBackground from "../../../components/pageBackground.component";
import InputForm from "../../../components/InputForm/inputForm.component";
import ErrorBox from "../../../components/errorBox.component";
import ErrorBoundary from "../../../components/errorBoundary.component";
import Typography from "@material-ui/core/Typography";
import { Button, Grid, List, ListItem, styled } from "@material-ui/core";
import Check from "@material-ui/icons/Check";
import Clear from "@material-ui/icons/Clear";
import "./login.css";
import CardBody from "../../../components/CardBody/cardBody.component";
/**
 * Change Password Component ( change password sending an E-mail
 * form and make a post request for user verification  )
 *
 * @export Class Component
 * @class Change Password
 * @extends {Component}
 * @returns Redux connect
 */

const OwnTypography = styled(Typography)(({ theme }) => ({
  fontSize: 12, fontWeight: 400, fontFamily: 'Mulish, sans-serif', color: "#575756", lineHeight: '19.2px'
}));

const OwnButton = styled(Button)(({ theme }) => ({
  padding: '12px 20px',
  marginRight: theme.spacing(2),
  backgroundColor: theme.palette.primary.main,
  width: "100%",
  height: '40px',
  display: "block",
  margin: "0",
  color: theme.palette.common.white,
  fontSize: '20px',
  fontWeight: 500,
  fontFamily: "'Mulish', sans-serif",
  textTransform: "none",
  lineHeight: '24px',
  boxShadow: "0px 4px 4px #00000033",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: theme.palette.primary.light,
    boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.25)",
  },
  '&.MuiButton-root, & .MuiButton-root': {
    borderRadius: '8px !important',
  },
  "&.Mui-disabled": {
    backgroundColor: theme.buttonUko.buttonUkoBackgroundDisabled,
    color: theme.buttonUko.buttonUkoColorDisabled,
  },
}));

export class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        user: "", //viene por query string o en la peticion
        token: "", //viene por query string
        oldpassword: "",
        confirmpassword: "",
        newpassword: "",
      },
      showButton: true,
      getAuthenticationResponse: {
        responseCode: "",
      },
      isInvalidToken: {
        ok: false,
        message: "",
      },
      isLoginAutomatic: false,
      getErrors: "",
      loading: "",
    };
    this.loginValidator = new SimpleReactValidator(reactValidatorOptions);
    try {
      var paramsChar = decodeURIComponent(window.location.search.substring(1));

      // The cipher-block chaining mode of operation maintains internal state, so to decrypt a new instance must be instantiated.
      var aesjs = require("aes-js");
      var aesCbc = new aesjs.ModeOfOperation.cbc(encryptionKey, encryptionIv);

      var encryptedText = aesjs.utils.hex.toBytes(
        new Buffer(paramsChar || "", "base64").toString("hex")
      );

      var decryptedBytes = aesCbc.decrypt(encryptedText);

      var decryptedText = aesjs.utils.utf8
        .fromBytes(decryptedBytes)
        .replace(/(?:\\[rn]|[\r\n]+|[\000-\031\200-\377])+/g, "");

      var objParameters = JSON.parse(decryptedText);

      this.state = {
        form: {
          user:
            props.history.location.state !== undefined
              ? props.history.location.state.user
              : objParameters.user, //viene por query string o en la peticion
          token: objParameters.token, //viene por query string
          isNewUser: objParameters.isNewUser,
          oldpassword: "",
          confirmpassword: "",
          newpassword: "",
        },
        showButton: true,
      };
    } catch (error) {
      console.error(error);
      //Sí se elimina el push, se debe tener en cuenta
      this.props.history.push({
        pathname: "/Alert",
        state: {
          message: "El enlace no es válido.",
          pagename: "/Login",
        },
      });
      return;
    }
  }
  
  setChangePassword = (e) => {
    e.preventDefault();
    if (this.loginValidator.allValid()) {
      //Compare both passwords
      if (this.comparePasswords(this.state.getErrors)) {
        const { user, newpassword, token, oldpassword, isNewUser} = this.state.form;
        var appname = this.props.appName;
        //Sí existe el token se utiliza el método Asignar.
        if (token === "" || token === undefined) {
          let userData = {
            user: user,
            password: oldpassword,
            newpassword: newpassword,
            appname: appname,
          };
          this.props.changePassword(userData, this.props.history);
        } else {
          let userData = {
            user: user,
            password: newpassword,
            token: token,
            appname: appname,
          };
          this.props.assignPassword(userData, this.props.history, this.props.tenant, isNewUser);
        }
      }
    } else {
      this.loginValidator.showMessages();
      this.forceUpdate();
    }
  };

  comparePasswords = (error) => {
    if (this.state.form.newpassword !== this.state.form.confirmpassword) {
      this.setState({
        getErrors: "Las contraseñas no coinciden.",
      });
      return false;
    } else {
      let passwordValidLength = isCorrectLength(this.state.form.newpassword, 12)
        ? true
        : false;
      let isCorrectValidMaxLength = isCorrectMaxLength(this.state.form.newpassword, 16)
        ? true
        : false;
      let passwordValidUpper = hasUpperLetter(this.state.form.newpassword)
        ? true
        : false;
      let passwordValidLower = hasLowerLetter(this.state.form.newpassword)
        ? true
        : false;
      let passValidNum = hasNumbers(this.state.form.newpassword) ? true : false;
      let passValidChar = hasSpecialCharacter(this.state.form.newpassword);
      if (
        passwordValidLength &&
        isCorrectValidMaxLength &&
        passwordValidUpper &&
        passwordValidLower &&
        passValidNum &&
        passValidChar
      ) {
        return true;
      } else {
        this.setState({
          getErrors:
            "La contraseña no cumple con el nivel mínimo de seguridad requerida.",
        });
        return false;
      }
    }
  };
  
  render() {
    return (
      <div className="login">
        <ErrorBoundary>
          <PageBackground></PageBackground>
          <CardBody
            cardStyles={{ minWidth: '370px', alignItems: 'center', minHeight: '550px', }}
            title={
              <span style={{
                whiteSpace: 'nowrap', textAlign: 'center',
                width: '100%', margin: '0 auto', fontSize: '24px'
              }}>
                {this.state.form.isNewUser ? "Activar cuenta" : "Cambiar contraseña"}
              </span>
            }
          >
            <form
              id="change-pass"
              onSubmit={(e) => this.setChangePassword(e)}
              autoComplete="off"
            >
              <hr></hr>
              <div style={{ width: '100%', wordBreak: 'break-word' }}>
                <Typography style={{
                  marginTop: '25px',
                  marginBottom: '-2px',
                  whiteSpace: 'normal', // por si hay restricción previa
                  lineHeight: '1.5'
                }}>
                  Usuario: {this.state.form.user}
                </Typography>
              </div>
              <br />
              <InputForm
                placeholder={"Nueva Contraseña*"}
                icon={"Lock"}
                type={"password"}
                id="newpassword"
                onChange={this.syncChanges}
                value={this.state.form.newpassword}
                validator={this.loginValidator}
                validateOptions={"required"}
              />
              <br />
              <InputForm
                placeholder={"Confirmar Contraseña*"}
                icon={"Lock"}
                type={"password"}
                id="confirmpassword"
                onChange={this.syncChanges}
                value={this.state.form.confirmpassword}
                validator={this.loginValidator}
                validateOptions={"required"}
              />
              <hr style={{ marginTop: '24px' }} />
              <Grid>
                <Typography style={{ marginTop: '20px', fontSize: 12, lineHeight: '19.2px', fontWeight: 400, fontFamily: 'Mulish, sans-serif', color: '#575756' }}>
                  Tu contraseña debe tener como mínimo:
                </Typography>
                <List dense={true}>
                  <ListItem>
                    {hasUpperLetter(this.state.form.newpassword) ? (
                      <Check style={{ fontSize: 15, color: "#119f45" }} />
                    ) : (
                      <Clear style={{ fontSize: 15, color: "#bf0c12" }} />
                    )}
                    <OwnTypography> Una mayúscula.</OwnTypography>
                  </ListItem>
                  <ListItem>
                    {hasLowerLetter(this.state.form.newpassword) ? (
                      <Check style={{ fontSize: 15, color: "#119f45" }} />
                    ) : (
                      <Clear style={{ fontSize: 15, color: "#bf0c12" }} />
                    )}
                    <OwnTypography>Una minúscula.</OwnTypography>
                  </ListItem>
                  <ListItem>
                    {hasNumbers(this.state.form.newpassword) ? (
                      <Check style={{ fontSize: 15, color: "#119f45" }} />
                    ) : (
                      <Clear style={{ fontSize: 15, color: "#bf0c12" }} />
                    )}
                    <OwnTypography>Un número.</OwnTypography>
                  </ListItem>
                  <ListItem>
                    <div style={{ display: 'flex' }}>
                      {hasSpecialCharacter(this.state.form.newpassword) ? (
                        <Check style={{ fontSize: 15, color: "#119f45" }} />
                      ) : (
                        <Clear style={{ fontSize: 15, color: "#bf0c12" }} />
                      )}
                      <div style={{ marginTop: '-2px' }}>
                        <OwnTypography> Un carácter especial </OwnTypography>
                      </div>
                    </div>
                  </ListItem>
                  <ListItem>
                    {isCorrectLength(this.state.form.newpassword, 12) && isCorrectMaxLength(this.state.form.newpassword, 16) ? (
                      <Check style={{ fontSize: 15, color: "#119f45" }} />
                    ) : (
                      <Clear style={{ fontSize: 15, color: "#bf0c12" }} />
                    )}
                    <OwnTypography>Entre 12 y 16 caracteres.</OwnTypography>
                  </ListItem>
                </List>
                {this.state.getErrors && (
                <ErrorBox value={this.state.getErrors}></ErrorBox>
                )}
              </Grid>
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', padding: 0 }}>
                <div style={{ width: '100%' }}>
                    <OwnButton 
                      type="submit"
                      loading={this.state.loading}
                      disabled={this.state.showButton}
                    >
                      <Typography style={{
                        fontSize: '16px',
                        fontWeight: 510,
                        color: 'inherit',
                        textTransform: 'none',
                        letterSpacing: '0.5px',
                      }}
                      > 
                        {this.state.form.isNewUser ? "Activar cuenta" :"Cambiar contraseña"} 
                      </Typography> 
                    </OwnButton>
                </div>
              </Grid>
            </form>
          </CardBody>
        </ErrorBoundary>
      </div >
    );
  }

  static getDerivedStateFromProps(nextProps, state) {
    let update = {};
    if (
      !!nextProps.authReducer.getAuthenticationResponse &&
      nextProps.authReducer.getAuthenticationResponse !==
      state.getAuthenticationResponse
    ) {
      update.getAuthenticationResponse =
        nextProps.authReducer.getAuthenticationResponse;
    }
    if (
      !!nextProps.loadingReducer.loading &&
      nextProps.loadingReducer.loading !== state.loading
    ) {
      update.loading = nextProps.loadingReducer.loading;
    }
    if (
      !!nextProps.authReducer.getAuthenticationResponse &&
      nextProps.authReducer.getAuthenticationResponse !==
      state.getAuthenticationResponse
    ) {
      update.getAuthenticationResponse =
        nextProps.authReducer.getAuthenticationResponse;
    }
    if (
      !!nextProps.authReducer.isInvalidToken &&
      nextProps.authReducer.isInvalidToken !== state.isInvalidToken
    ) {
      update.isInvalidToken = nextProps.authReducer.isInvalidToken;
    }
    if (
      !!nextProps.authReducer.sendActivationEmail &&
      nextProps.authReducer.sendActivationEmail !== state.sendActivationEmail
    ) {
      update.sendActivationEmail = nextProps.authReducer.sendActivationEmail;
    }

    if (
      !!nextProps.authReducer.isLoginAutomatic &&
      nextProps.authReducer.isLoginAutomatic !== state.isLoginAutomatic
    ) {
      update.isLoginAutomatic = nextProps.authReducer.isLoginAutomatic;
    }
    return Object.keys(update).length ? update : null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.loading !== this.state.loading) {
      this.state.loading
        ? this.setState({ loading: true })
        : this.setState({ loading: false });
    }

    if (prevState.isInvalidToken !== this.state.isInvalidToken) {
      this.props.history.push({
        pathname: "/resendemail",
        state: {
          message: this.state.isInvalidToken.message,
          userData: {
            appname: this.props.appName,
            username: this.state.form.user,
          },
        },
      });
    }
    if (
      prevState.getAuthenticationResponse !==
      this.state.getAuthenticationResponse
    ) {
      if (this.state.getAuthenticationResponse.responseCode === 200) {
        if (
          !!this.state.getAuthenticationResponse.token &&
          this.state.getAuthenticationResponse.token !== ""
        ) {
          window.location.assign(this.state.getAuthenticationResponse.url);
        } else {
          this.cleanChangeForm();
        }
      } else {
        this.setState({
          getErrors: this.state.getAuthenticationResponse.message,
          loading: false,
        });
      }
    }
  }
  
  syncChanges = (e) => {
    const id = !!e.target.id ? e.target.id : e.target.name;
    const value = e.target.value;

    this.setState((prevState) => {
      const updatedForm = {
        ...prevState.form,
        [id]: value,
      };
      const password = updatedForm.newpassword;
      const confirmPassword = updatedForm.confirmpassword;

      const isPasswordValid =
        isCorrectLength(password, 12) &&
        isCorrectMaxLength(password, 16) &&
        hasUpperLetter(password) &&
        hasLowerLetter(password) &&
        hasNumbers(password) &&
        hasSpecialCharacter(password);

      const shouldDisableButton =
        !password?.trim() ||
        !confirmPassword?.trim() ||
        !isPasswordValid;
      return {
        form: updatedForm,
        getErrors: "",
        showButton: shouldDisableButton,
      };
    });
  };

  cleanChangeForm = () => {
    this.setState({
      form: {
        user: "",
        token: "",
        newpassword: "",
        confirmpassword: "",
        oldpassword: "",
      },
      getAuthenticationResponse: {
        responseCode: "",
      },
      loading: "",
    });
    this.loginValidator.hideMessages();
  };

  componentDidMount() {
    if (this.state.form.token) {
      if (this.state.isLoginAutomatic === undefined) {
        this.props.tokenValidation(
          this.state.form.user,
          this.state.form.token,
          this.props.appName,
          this.props.history,
        );
      }
    }
  }
}

ChangePassword.propTypes = {
  assignPassword: PropTypes.func.isRequired,
  authReducer: PropTypes.object.isRequired,
  loadingReducer: PropTypes.object.isRequired,
  changePassword: PropTypes.func.isRequired,
  tokenValidation: PropTypes.func.isRequired,
  SendUserActivationEmail: PropTypes.func.isRequired,
  tenant: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
  loadingReducer: state.loadingReducer,
});

export default connect(mapStateToProps, {
  assignPassword,
  changePassword,
  tokenValidation,
  SendUserActivationEmail,
})(ChangePassword);

